var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-dialogContainer"},[_c('BaseBusiness',{ref:_vm.item.name,attrs:{"formParam":_vm.item,"defaultData":_vm.msg}}),_c('div',{staticClass:"h-clear-rowMg"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }